import { IsNotEmpty, IsDateString } from "class-validator";

export class DuplicateEventDto {
  @IsNotEmpty()
  @IsDateString()
  start_date: string;
}

